/*
* @Description: 写这段代码的时候，只有上帝和我知道它是干嘛的。现在，只有上帝知道。
* @Author: 951375403@qq.com
* @Date: 2021-04-105 10:54:52
* @LastEditors: jarvis
* @LastEditTime: now
*/

/**
 * 判断当前浏览器的平台
 * @returns 浏览器平台
 */
export function judgeClient() {
  let u = navigator.userAgent;
  let ua = u.toLowerCase();
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return 'weixin'
  } else if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'ios'
  } else {
    return '请使用正版浏览器'
  }
}

/**
 * 格式化金额，小数点后面保留两位
 * @param {String} num 
 * @returns 
 */
export function keepTwoDecimalFull(num) {
  var result = parseFloat(num);
  if (isNaN(result)) {
    // alert('传递参数错误，请检查！');
    return 0.00;
  }
  result = Math.round(num * 100) / 100;
  var s_x = result.toString(); //将数字转换为字符串

  var pos_decimal = s_x.indexOf('.'); //小数点的索引值

  // 当整数时，pos_decimal=-1 自动补0
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += '.';
  }

  // 当数字的长度< 小数点索引+2时，补0
  while (s_x.length <= pos_decimal + 2) {
    s_x += '0';
  }
  return s_x;
}

/**
 * 判断是否是app平台
 * @returns 
 */
export function isApp() {
  return navigator.userAgent.indexOf('Html5Plus') > -1
}

/**
 * 时间格式化
 * @param {String} fmt 需要格式化的时间格式
 * @param {Date} date 时间对象
 * @returns 格式化的后的时间
 * 
 * 使用示例：
 * let date = new Date()
 * dateFormat("YYYY-mm-dd HH:MM", date)
 */
export function dateFormat(fmt, date) {
  if (date) {
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString() // 秒

      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
    };
    return fmt;
  } else {
    return ""
  }
}


/**
 * 网络图片转base64图片
 * @param {String} imgUrl 网络图片地址
 * @param {*} cb 回调函数，返回base64
 */
export function getBase64(imgUrl, cb) {
  var base64 = null
  window.URL = window.URL || window.webkitURL;
  var xhr = new XMLHttpRequest();
  xhr.open("get", imgUrl, true);
  // 至关重要
  xhr.responseType = "blob";
  xhr.onload = function () {
    if (this.status == 200) {
      //得到一个blob对象
      var blob = this.response;
      // 至关重要
      let oFileReader = new FileReader();
      oFileReader.onloadend = function (e) {
        // 此处拿到的已经是 base64的图片了
        base64 = e.target.result;

        cb(base64)

      };
      oFileReader.readAsDataURL(blob);

    }
  }
  xhr.send();

}

/**
 * foueach的简单封装
 * @param {Array} arr 需要遍历的数组
 * @param {Objcet} cb 回调函数
 */
export function forEach(arr, cb) {
  for (let i = 0; i < arr.length; i++) {
    cb(arr[i], i, arr)
  }
}
/**
 *                    _ooOoo_
 *                   o8888888o
 *                   88" . "88
 *                   (| -_- |)
 *                    O\ = /O
 *                ____/`---'\____
 *              .   ' \\| |// `.
 *               / \\||| : |||// \
 *             / _||||| -:- |||||- \
 *               | | \\\ - /// | |
 *             | \_| ''\---/'' | |
 *              \ .-\__ `-` ___/-. /
 *           ___`. .' /--.--\ `. . __
 *        ."" '< `.___\_<|>_/___.' >'"".
 *       | | : `- \`.;`\ _ /`;.`/ - ` : | |
 *         \ \ `-. \_ __\ /__ _/ .-` / /
 * ======`-.____`-.___\_____/___.-`____.-'======
 *                    `=---='
 *
 * .............................................
 *          佛祖保佑             代码无BUG
 */


// WEBPACK FOOTER //
// ./src/utils/judgeClient.js